<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.category" id="category" label="補助類別">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in categorys" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>學號-學生姓名</th>
                            <th>補助類別</th>
                            <th>減免金額</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.DeductionID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.DeductionID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.DeductionID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="補助類別">{{item.Category|category}}</td>
                        <td data-th="減免金額">{{item.Amount}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="category">
                <div is="option" v-for="o in categorys" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/deduction.xlsx" url="/api/deduction/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './deductionDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'deduction',
        api: '/api/deduction/',
        components: { Detail },
        data: { categorys: [] },
        created: function () {
            window.categorys = [];
            this.$parameter.deduction().then((res) => { window.categorys = this.categorys = res.data; });
        },
        filters: {
            category: function (value) { let a = window.categorys.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
    });
</script>

<style>
</style>